import { Button, Col, Layout, List, Row, Tooltip } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/images/logo-new_taimuihongsg.png";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import FlagVI from "../../../assets/images/flag-vi.png";
import FlagEN from "../../../assets/images/flag-en.png";
import { useTranslation } from "react-i18next";

const headerStyle = {
  textAlign: "center",
  color: "#333",
  height: 100,
  paddingInline: 48,
  lineHeight: "64px",
  backgroundColor: "#fff",
};

const languages = [
  {
    key: "vi",
    name: "Vietnamese",
    flag: FlagVI,
  },
  {
    key: "en",
    name: "English",
    flag: FlagEN,
  },
];

const Header = () => {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  const data = [
    {
      topTitle: t("addressDetail1"),
      bottomTitle: (
        <a href="https://goo.gl/maps/Qye3RYL7vwRsZdqN9">
          {t("addressDetail2")}
        </a>
      ),
      icon: <FaLocationDot color="var(--main-color)" />,
    },
    {
      topTitle: "HOTLINE",
      bottomTitle: <a href="tel:02838213456">(028) 38.213.456</a>,
      icon: <FaPhone color="var(--main-color)" />,
    },
    {
      topTitle: "MAIL",
      bottomTitle: (
        <a href="mailto:ketoan@taimuihongsg.com">ketoan@taimuihongsg.com</a>
      ),
      icon: <MdEmail color="var(--main-color)" />,
    },
  ];

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language);

    localStorage.setItem("language", language);
  };
  return (
    <Layout.Header style={headerStyle}>
      <Row>
        <Col xs={20} xl={6}>
          <div style={{ height: "100px", lineHeight: "100px" }}>
            <Link to="/">
              <img
                src={Logo}
                alt="logo"
                style={{
                  width: "auto",
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "70px",
                  verticalAlign: "middle",
                }}
              />
            </Link>
          </div>
        </Col>
        <Col xs={0} xl={14}>
          <List
            dataSource={data}
            grid={{ gutter: 16, column: [10, 7, 7] }}
            style={{ height: 100 }}
            renderItem={(item) => (
              <List.Item
                style={{
                  display: "table-cell",
                  verticalAlign: "middle",
                  textAlign: "left",
                  height: 100,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    gap: 16,
                  }}
                >
                  <div>
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        lineHeight: "50px",
                        display: "inline-block",
                        fontSize: "25px",
                        border: "1px solid #e6e6e6",
                        borderRadius: "50%",
                      }}
                    >
                      {item.icon}
                    </div>
                  </div>
                  <div>
                    <p
                      style={{
                        fontSize: "15px",
                        lineHeight: "20px",
                        textTransform: "uppercase",
                        color: "#2d2d2d",
                        fontWeight: "bold",
                        margin: "0 0 14px",
                      }}
                    >
                      {item.topTitle}
                    </p>
                    <p
                      style={{
                        margin: "0 0 14px",
                      }}
                    >
                      {item.bottomTitle}
                    </p>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </Col>
        <Col xs={4} xl={4}>
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Tooltip
              title={
                selectedLanguage === "vi"
                  ? "Tiếng Việt / Tiếng Anh"
                  : "English / Vietnamese"
              }
            >
              <Button
                onClick={() =>
                  handleLanguageChange(selectedLanguage === "vi" ? "en" : "vi")
                }
                ghost
                style={{ padding: 0 }}
              >
                <img
                  src={
                    languages.find((lang) => lang.key === selectedLanguage).flag
                  }
                  alt="flag"
                  style={{ width: 50, height: 30 }}
                />
              </Button>
            </Tooltip>
          </div>
        </Col>
      </Row>
    </Layout.Header>
  );
};

export default Header;
